import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { ImageGetFolderPipe } from '../../../pipes/image-get-folder.pipe';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/empty';

export type IIPSrvImageProtocol = 'iip' | 'iiif';
export type IIPSrvImageSize = 'thumbnail' | 'small' | 'medium' | 'large';

@Component({
    selector: 'app-iipsrv-image',
    templateUrl: './iipsrv-image.component.html',
    styleUrls: ['./iipsrv-image.component.css'],
    providers: [ ImageGetFolderPipe ]
})
export class IIPSrvImageComponent implements OnChanges {
    @Input() src: String = '';
    @Input() private protocol: IIPSrvImageProtocol;
    @Input() private size: IIPSrvImageSize;
    dataUrl$: Observable<SafeUrl>;
    loading: boolean; // = true;
    available: boolean; // = true;
    @Output() loadingEvent = new EventEmitter<boolean>();

    constructor(
        private http: HttpClient,
        private domSanitizer: DomSanitizer,
        private imageGetFolderPipe: ImageGetFolderPipe
        ) {
    }

    ngOnChanges(): void {
       this.loading = true;
       this.available = true;
       this.loadingEvent.emit(true);
       this.dataUrl$ = this.loadSourceImage();
    }

    private loadSourceImage(): Observable<SafeUrl> {
        return this.http.get(
            this.getImageUrl(),
            {
                headers: new HttpHeaders({
                    'Authorization': environment.apiKey,
                    'X-PhiBor-App': environment.phiborApp
                }),
                responseType: 'blob'
            }
        )
        .map(blob => {
            this.loading = false;
            this.loadingEvent.emit(false);
            return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
            })
        .catch((err: HttpErrorResponse) => {
            // console.error('ERROR', err);
            this.loading = false;
            this.loadingEvent.emit(false);
            this.available = false;
            return Observable.empty<SafeUrl>();
        })
        ;
    }

    private getImageUrl(): string {
        let imageUrl = '';

        /* Check for image server protocol */
        switch (this.protocol) {
            case 'iip': {
                imageUrl += environment.endpoints.images.iip;
                break;
            }
            case 'iiif': {
                imageUrl += environment.endpoints.images.iiif;
                break;
            }
        }

        /* Add image full path */
        imageUrl += '/' + this.imageGetFolderPipe.transform(this.src) + '/' + this.src;

        /* Check for image size */
        switch (this.size) {
            case 'thumbnail': {
                break;
            }
            case 'small': {
                imageUrl += '&HEI=211&CVT=jpeg';
                break;
            }
            case 'medium': {
                break;
            }
            case 'large': {
                break;
            }
        }

        return imageUrl;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/iipsrv-image/iipsrv-image.component.ts